/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownInterviewOutcomeStatus } from '../models/db_DropdownInterviewOutcomeStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InterviewOutcomeStatuses {
    /**
     * Get a list of interview outcome statuses
     * @returns db_DropdownInterviewOutcomeStatus OK
     * @throws ApiError
     */
    public static listInterviewOutcomeStatuses(): CancelablePromise<Array<db_DropdownInterviewOutcomeStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-outcome-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
